import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreModule } from '../core';
import { SharedModule } from '../shared';
import { UIModule } from '../ui.module';

import { BaseComponent } from './base.component';
import { TutorialStepsComponent } from './tutorial-steps.component';

import { SimulationModeRoutingModule } from './simulation-mode.routing';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        UIModule,

        SimulationModeRoutingModule
    ],
    declarations: [
        BaseComponent,
        TutorialStepsComponent,
    ]
})
export class SimulationModeModule { }
